import { isPlatformBrowser, isPlatformServer, PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
	selector: 'app-statement-dialog',
	templateUrl: './statement-dialog.component.html',
	styleUrls: ['./statement-dialog.component.scss'],
})
export class StatementDialogComponent implements OnInit {
	/** 為 false 時不渲染彈窗與 SSR 靜態聲明 */
	readonly enabled = false;
	/** 進網站後顯示；關閉後本次頁面生命週期內不再開啟 */
	visible = false;
	/** SSR / prerender 時為 true，用來輸出靜態版聲明供搜尋引擎索引 */
	readonly isServer: boolean;
	/** 靜態版聲明只輸出在首頁，避免全站重複內容 */
	readonly isHome: boolean;

	constructor(
		@Inject(PLATFORM_ID) private platformId: object,
		platformLocation: PlatformLocation,
	) {
		this.isServer = isPlatformServer(this.platformId);
		// 伺服器端的 pathname 即為本次渲染的網址，不必等路由導航完成
		this.isHome = platformLocation.pathname.replace(/\/+$/, '') === '';
	}

	ngOnInit(): void {
		if (this.enabled && isPlatformBrowser(this.platformId)) {
			this.visible = true;
		}
	}

	close(): void {
		this.visible = false;
	}
}
